import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/shared/constants';
import { LocalizationService } from 'src/app/shared/localization/localization.service';
import { LocalDataService } from 'src/app/shared/services/local-data.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {

  constructor(
    public _dialogRef: MatDialogRef<AboutComponent>,
    private _localDataService: LocalDataService,
    public _localizationService: LocalizationService
    ) {
      _localDataService.selectedScreen = ['about'];
      _localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, [...Constants.Localization.commonAreas, ..._localDataService.selectedScreen]);
    }

  onDialogCancel(): void {
    this._dialogRef.close();
  }
}
